function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
export function CloudIcon(_0) {
    let { color = '#7B84A3' } = _0, props = _object_without_properties(_0, [
        "color"
    ]);
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M15.3608 7.6717C14.8509 6.50108 13.9712 5.53002 12.8565 4.9074C11.7419 4.28479 10.4538 4.04499 9.18985 4.22477C7.92586 4.40455 6.75572 4.99399 5.85883 5.90271C4.96193 6.81144 4.3878 7.98929 4.22446 9.25567C3.42974 9.44601 2.73258 9.92163 2.26538 10.5922C1.79819 11.2628 1.59349 12.0816 1.69017 12.8931C1.78685 13.7047 2.17816 14.4525 2.7898 14.9945C3.40144 15.5365 4.19081 15.835 5.008 15.8333H14.1771C15.1768 15.8305 16.1423 15.4685 16.8973 14.8131C17.6524 14.1578 18.1467 13.2528 18.2902 12.2633C18.4337 11.2738 18.2168 10.2657 17.6791 9.42278C17.1413 8.5799 16.3185 7.95842 15.3608 7.6717ZM14.1771 14.166H5.008C4.56586 14.166 4.14182 13.9903 3.82918 13.6776C3.51653 13.3649 3.34089 12.9408 3.34089 12.4986C3.34089 12.0564 3.51653 11.6323 3.82918 11.3196C4.14182 11.007 4.56586 10.8313 5.008 10.8313C5.22907 10.8313 5.44109 10.7435 5.59741 10.5871C5.75374 10.4308 5.84156 10.2187 5.84156 9.99763C5.84369 9.01163 6.19522 8.05832 6.83371 7.30704C7.4722 6.55577 8.3563 6.05519 9.32894 5.89422C10.3016 5.73326 11.2998 5.92235 12.1462 6.42788C12.9926 6.93342 13.6325 7.72267 13.9521 8.65543C14.001 8.79713 14.0871 8.92303 14.2016 9.01986C14.316 9.11669 14.4544 9.18087 14.6022 9.20565C15.2132 9.3184 15.7604 9.6546 16.1371 10.1487C16.5138 10.6429 16.6931 11.2596 16.64 11.8787C16.5869 12.4978 16.3053 13.075 15.85 13.4978C15.3947 13.9207 14.7984 14.1588 14.1771 14.166Z",
            fill: color
        })
    }));
}
